import { Environment } from '.';

/**
 * Attempts to determine the environment of BIW's API to use. This is used
 * in a number of endpoints such as the endpoint for translation bundles.
 * 
 * @returns { string }
 */
export function getBiwApiEnv( _appEnv ) {
    return Environment.QA;
}
